import { AwsClient } from "aws4fetch";
import { aws4Interceptor } from "aws4-axios";
import {
  APPLICATION_NAME,
  TITLE_DIVIDER,
  START_YEAR,
  END_YEAR,
  OLD_CENTURY,
  NEW_CENTURY,
  ALLOCATION_ORDER_ONGOING,
  ALLOCATION_ORDER_CREATED,
} from "@utils/constant";

import RoutesList from "@shared/RoutesList";
import { RISK, LOW, HIGH, MEDIUM } from "@components/DataTable/Constants";
import config from "@src/config";

export const addHyphenToNumber = (number, position) => {
  let value = number || "";
  const regEx = new RegExp(`(\\d{${position}})`, "g");
  value = value.replace(/([^0-9 -\s])/gm, "").replace(/\s+/g, "");
  value = value && value.replace(/([^0-9 -\s])/gm, "").replace(/\s+/g, "");
  if (value && (value.length > position + 1 || value.length < position + 1)) {
    value = value.replace(/-/g, "");
  }
  if (value && value.length > position && value.indexOf("-") !== position) {
    value = value.replace(regEx, "$1-");
  }
  return value;
};

export const setTitle = () => {
  const routePath = window?.location?.pathname?.split("/");
  const routePathName = `/${routePath[routePath.length - 1]}`;
  const route = RoutesList.find((obj) => obj.url.includes(routePathName));
  if (route) {
    document.title = APPLICATION_NAME + TITLE_DIVIDER + route.title;
  }
};

export const isAuthenticated = () => {
  if (localStorage.getItem("aws-credentials")) {
    return true;
  } else {
    return false;
  }
};

export const getLabelColor = (value) => {
  switch (value) {
    case RISK:
      return "var(--alert)";
    case LOW:
      return "var(--success)";
    case MEDIUM:
      return "var(--primary)";
    case HIGH:
      return "var(--alert)";
    default:
      return "var(--primary)";
  }
};

export const getAWSCredentials = async () => {
  return await new Promise((resolve) => {
    const awsCredentials = JSON.parse(localStorage.getItem("aws-credentials"));
    if (awsCredentials) {
      const { accessKeyId, secretAccessKey, sessionToken } = awsCredentials;

      const aws = new AwsClient({
        accessKeyId,
        secretAccessKey,
        sessionToken,
        region: "eu-north-1",
        service: "execute-api",
      });
      if (aws) {
        resolve(aws);
      } else {
        localStorage.clear();
        window.location = "/login";
        // reject(aws);
      }
    } else {
      // reject(awsCredentials);
      localStorage.clear();
      window.location = "/login";
    }
  });
};

export const parseQueryParams = (queryParam = []) => {
  let queries;
  if (queryParam.length > 0) {
    queries = queryParam
      .map((obj) => {
        if (obj[1] !== undefined && obj[1] !== null) {
          return obj.join("=");
        }
        return undefined;
      })
      .filter((o) => o)
      .join("&");
  }
  return `?${queries}`;
};

export const numberFormat = (num = "") => {
  return num
    ? Number(num)
        .toFixed(2)
        .replaceAll(".", ",")
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1 ")
    : 0;
};

export const numberFormatWithoutDecimal = (num = "") => {
  return num
    ? Number(num)
        .toFixed(0)
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1 ")
    : 0;
};

export const removeDecimals = (num = 0) => {
  return num ? Number(num).toFixed(0) : num;
};

export const getAwsCredentialsForAxios = () => {
  const customCredentialsProvider = {
    getCredentials: async () => {
      const awsCredentials = JSON.parse(
        localStorage.getItem("aws-credentials")
      );
      const {
        accessKeyId = "",
        secretAccessKey = "",
        sessionToken = "",
      } = awsCredentials || {};

      return Promise.resolve({
        accessKeyId: accessKeyId,
        secretAccessKey: secretAccessKey,
        sessionToken: sessionToken,
      });
    },
  };

  return new aws4Interceptor(
    {
      region: "eu-north-1",
      service: "execute-api",
    },
    customCredentialsProvider
  );
};

export const getLastValueInArray = (values) => {
  return values.length ? values[values.length - 1].value : "";
};

export const getBrickIdOfUser = (details) => {
  const { BrickId = "" } = details ? details[0] : {};
  return BrickId;
};

const replaceNaN = (value) => {
  return value !== "NaN" ? Number(value) : 0;
};

export const convertFundReturnsToNumber = (funds = []) => {
  return funds.map((o) => {
    const { returns = {} } = o;
    const { week = 0, month = 0, halfYear = 0, year = 0 } = returns;
    const newReturns = {};
    newReturns.week = replaceNaN(week);
    newReturns.month = replaceNaN(month);
    newReturns.halfYear = replaceNaN(halfYear);
    newReturns.year = replaceNaN(year);
    newReturns["3year"] = replaceNaN(returns && returns["3year"]);
    newReturns["5year"] = replaceNaN(returns && returns["5year"]);
    return { ...o, returns: newReturns };
  });
};

export const getColor = (props) => {
  const { secondary, alert, white, success } = props;
  switch (true) {
    case secondary:
      return "var(--blue-light)";
    case alert:
      return "var(--alert)";
    case white:
      return "var(--white)";
    case success:
      return "var(--success)";
    default:
      return "var(--text)";
  }
};

export const parseHoldingsFromFiveYears = (data, value) => {
  return data && data.length > value ? data.slice(-Number(value)) : data;
};

export const calulatePercentOfHoldingsFromFiveYears = (
  data = [],
  count = 0
) => {
  const totalValues = data.length ? data.slice(-Number(count) - 1) : [];
  const values = data.length > count ? data.slice(-Number(count)) : data;
  const startValue = totalValues.length ? Number(totalValues[0].value) : 0;
  return values?.map((o) => {
    const { date = "", value = 0 } = o;
    const percentage = Number(value) - startValue;
    return { date, value: Number(percentage).toFixed(2) };
  });
};

export const redirectToBSSfo = (status = "logout") => {
  window.location.href = `${config.EXTERNAL_URL}/inloggning/brightsave?status=${status}`;
};

/* Utility to add either 19 or 20 infront of the entered PHONE NO,
 1911-1999  (11-99)  and 2000-2010 (00-10) */

export const getPinWithFullYear = (pin) => {
  const year = String(pin).slice(0, 2);
  return year >= START_YEAR && year <= END_YEAR
    ? NEW_CENTURY + pin
    : OLD_CENTURY + pin;
};

export const customSortForFees = (event, data = []) => {
  const sortedList = data.map((obj) => {
    const feeNumeric = typeof obj.fee === "undefined" ? "0%" : obj.fee;
    return {
      ...obj,
      feeNumeric: parseFloat(feeNumeric.split("%")[0].replace(",", ".")),
    };
  });
  sortedList.sort((a, b) => {
    return (a.feeNumeric - b.feeNumeric) * event.order;
  });
  return sortedList;
};

export const customSortSustainability = (event, data = []) => {
  const sustainabilityCode = {
    "Artikel 9": 2,
    "Artikel 8": 1,
    Neutral: 0,
  };
  const sortedList = data.map((obj) => {
    return {
      ...obj,
      ESGcode: obj.ESG ? sustainabilityCode[obj.ESG] : -1,
    };
  });
  sortedList.sort((a, b) => {
    return (a.ESGcode - b.ESGcode) * -event.order;
  });
  return sortedList;
};

export const customSortForMorningStar = (event, data = []) => {
  return data.sort((a, b) => {
    return (a.rating - b.rating) * -event.order;
  });
};

export const checkAcchasActiveInsurances = (accountDetails) => {
  const { accounts = [] } = accountDetails;
  const filterActiveInsurances = accounts.filter(
    (o) =>
      o.pendingOrders &&
      o.pendingOrders.state !== ALLOCATION_ORDER_ONGOING &&
      o.pendingOrders.state !== ALLOCATION_ORDER_CREATED
  );
  return {
    isDisabled: filterActiveInsurances.length === 0,
    noPositions: filterActiveInsurances.length
      ? !filterActiveInsurances.find(
          (obj) => obj?.positions?.detail?.length > 0
        )
      : false,
    hasCrossedMaxLimitOfFunds: filterActiveInsurances.length
      ? !!filterActiveInsurances.find(
          (obj) => obj?.positions?.detail?.length > 100
        )
      : false,
  };
};

export const calculateRows = (isNotificationScreen) => {
  const width = window.innerWidth;
  if (isNotificationScreen) {
    if (width < 768) return 1;
    if (width >= 768 && width < 1024) return 3;
    return 5;
  } else {
    return 10;
  }
};

export const normalizeStrings = (obj) => {
  if (typeof obj === "string") {
    return obj.normalize("NFC"); // Normalize to NFC
  } else if (Array.isArray(obj)) {
    return obj.map(normalizeStrings);
  } else if (typeof obj === "object" && obj !== null) {
    return Object.keys(obj).reduce((acc, key) => {
      // Set default value to empty string if the value is undefined
      acc[key] = normalizeStrings(obj[key] === undefined ? "" : obj[key]);
      return acc;
    }, {});
  }
  return obj;
};
